import { axiosAdapter } from 'foca-openapi/adapters/axios';
import { OpenapiClientParrot } from 'src/openapi/parrot';
import http from './http';

export const parrotApi = new OpenapiClientParrot(axiosAdapter(http, (res) => res));
